import React from "react";
import { TradeDetailsSection } from "../../components/DetailsSection/TradeDetailsSection";
import { ProgressBar } from "../../components/ProgressBar/ProgressBar";
import { Spacer } from "../../components/general/Spacer/Spacer";
import {
  getErrorMessageFromOrderError,
  getErrorMessageFromQuoteError,
  getQuoteWarnings,
} from "../../config/errorCodes";
import { useTimedFetchBalances } from "../../hooks/useTimedFetchBalances";
import { useTimedQuoteRefetch } from "../../hooks/useTimedQuoteRefetch";
import { useUrlNetworkParams } from "../../hooks/useUrlNetworkParams";
import { GlobalStore } from "../../store/global/GlobalStore";
import { Amount } from "../../types/amount";
import { OrderStatus } from "../../types/orderStatus";
import { InitialActionButton } from "./InitialActionButton";
import "./OrderEntry.css";
import { OrderEntryHeader } from "./OrderEntryHeader";
import { ErrorSection } from "./sections/ErrorSection";
import { MakerSection } from "./sections/MakerSection";
import { TakerSection } from "./sections/TakerSection";
import { WarningSection } from "./sections/WarningSection";

export const OrderEntry: React.FC = () => {
  const orderStatus = GlobalStore.useState(s => s.orderStatus);
  const quoteError = GlobalStore.useState(s => s.quoteError);
  const orderError = GlobalStore.useState(s => s.orderError);
  const quote = GlobalStore.useState(s => s.quote);

  // Subscribes to network params and updates the store when they change
  // TODO: update query params without pushing to history
  useUrlNetworkParams();
  //Re-fetches quote at the specified interval
  useTimedQuoteRefetch();
  useTimedFetchBalances();
  const { networkFee } = GlobalStore.useState(s => {
    return { networkFee: s.quote?.usdGasFee };
  });
  const errorMessageFromQuoteError = getErrorMessageFromQuoteError(quoteError);
  const errorMessageFromOrderError = orderError
    ? getErrorMessageFromOrderError(orderError)
    : undefined;
  const error = errorMessageFromQuoteError ?? errorMessageFromOrderError;
  const warning = getQuoteWarnings(quote);

  return (
    <>
      <OrderEntryHeader />
      <TakerSection />
      <MakerSection />
      {!error && !warning && <Spacer height="12px" />}
      {error && <ErrorSection error={error} />}
      {warning && <WarningSection warning={warning} />}
      <TradeDetailsSection
        networkFee={networkFee ?? Amount.ZERO}
        visible={orderStatus === OrderStatus.QUOTING}
      />
      <div className={"progress-bar-container"}>
        <ProgressBar step={1} />
      </div>
      <InitialActionButton />
    </>
  );
};
